export default "__VITE_ASSET__7e41aeb0__"